{
  "version": 1,
  "asset_id": "33ca411b-e58e-4d9c-9c20-4a81ac53d609",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/33ca411b-e58e-4d9c-9c20-4a81ac53d609/beverly-hills-shingle-roof-tear-off-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/33ca411b-e58e-4d9c-9c20-4a81ac53d609/beverly-hills-shingle-roof-tear-off-768w.webp",
  "original_filename": "beverly-hills-shingle-roof-tear-off-768w.webp",
  "size": 80810,
  "content_type": "image/webp",
  "created_at": "2026-07-29T14:07:19Z"
}
